import dayjs from 'dayjs'
/**
 * 判断是否为空
 * @param {*} value
 * @returns
 */
export function isEmpty(value) {
  if (
    value == '' ||
    value == null ||
    value == 0 ||
    value == false ||
    value == undefined ||
    value == 'undefined'
  ) {
    return true
  }

  return false
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 判断是否为 动态路由
 * @param {*} s
 */
export function isDynamicRoutes(s) {
  return /DynamicRoutes/.test(s)
}

export function unixDate2Str(date, format) {
  format = format || 'YYYY-MM-DD HH:mm:ss'
  return dayjs(date).format(format)
}

export function toFullUrl(url) {
  return window.location.host + url
}

export function checkPlatform() {
  let p = navigator.platform
  let u = navigator.userAgent
  let is_android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
  let is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (
    p == 'Win32' ||
    p == 'Win64' ||
    p == 'MacPPC' ||
    p == 'MacIntel' ||
    p == 'X11' ||
    p == 'Linux i686'
  ) {
    //PC调试环境
    console.log('PC环境--供PC端调试')
    return 'pc'
  } else {
    if (is_android) {
      //Android终端
      console.log('Mobile环境--Android移动端')
      return 'android'
    } else if (is_ios) {
      //IOS终端
      console.log('Mobile环境--IOS移动端')
      return 'ios'
    }
  }
}

export function openInAppUrl(url) {
  let fullUrl = toFullUrl(url)
  let platform = checkPlatform()
  let openUrl
  switch (platform) {
    case 'ios':
      openUrl =
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.zjonline.iwenling&ios_scheme=wenling://' +
        fullUrl
      break
    case 'android':
      openUrl =
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.zjonline.iwenling&android_schema=wenling://' +
        fullUrl
      break
    default:
      openUrl = 'https://vapp.tmuyun.com/client/download.html?tenant_id=3'
      break
  }
  return openUrl
}

export function isPhone(str) {
  if (str.length != 11) {
    return false
  } else {
    var regPartton = /1[3-9]+\d{9}/
    if (!str || str == null) {
      return false
    } else if (!regPartton.test(str)) {
      return false
    }
  }
  return true
}

export function redirect(url) {
  window.location.href = url
}

/**
 * 对象深拷贝
 */
export const deepClone = (data) => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
